import React, { memo, useCallback } from 'react';
import noop from 'lodash/noop';
import Icon from '../icon';
import { stopEvent, stopPropagation } from '../_util/EventManager';
const CloseButton = memo((props) => {
    const { onClose = noop, value, index } = props;
    const handleClick = useCallback((e) => {
        stopEvent(e);
        onClose(e, value, index);
    }, [onClose, value, index]);
    return (React.createElement(Icon, { type: "cancel", onClick: handleClick, onFocus: stopPropagation, onMouseDown: stopEvent, tabIndex: -1 }));
});
CloseButton.displayName = 'CloseButton';
export default CloseButton;
